/**
 * This is how we can control feature flags going forward to ensure no-op while
 * we develop new large features.
 *
 * Adding a new feature flag is very simple, and all we need to do is some
 * conditional rendering using the checkFlag function below
 * 
 * If the flag does not appear in the map, we default to true. We do not want to 
 * gate items if the flag isn't in the map.
 * This is most likely to happen when we take flags out of the map, given they
 * are fully live.
 */

const currentCompanyName = JSON.parse(localStorage.getItem("arpariAffiliatedCompany"))?.company_name || "";

const featureFlags = {
  paymentsV2: true,
  dashboardEditor: true,
  otpPayments: true,
  limitedUserAccess: true,
  transactionsCounterparties: true,
}

const checkFlag = (flagName) => {
  const flag = featureFlags[flagName]
  if (flag === undefined) {
    // Note above 
    return true
  }
  return flag
}

export default checkFlag
